export const GetMyRoles = async (jwtToken) => {
    const response = await fetch(process.env.REACT_APP_API_BASE_URL + '/me/roles', {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    });
    if (!response.ok) throw new Error('Failed to fetch roles');
    return response.json();
};

export const GetAllUserRoles = (jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/user-roles', {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => callback(res))
    .catch(() => callback([]));
};

export const UpsertUserRole = (email, roles, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/user-roles/' + encodeURIComponent(email), {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`
        },
        body: JSON.stringify({ email, roles })
    })
    .then(res => res.json())
    .then(res => callback(res))
    .catch(() => callback(null));
};

export const DeleteUserRole = (email, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/user-roles/' + encodeURIComponent(email), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => callback(res.ok))
    .catch(() => callback(false));
};
